<template>
  <div
    class="dashboard-template"
    v-bind:class="[isActive ? 'ativoPadding' : 'inativoPadding']"
  >
    <div class="side-menu" v-bind:class="[isActive ? 'ativo' : 'inativo']">
      <router-link :to="'/admin/Home'" v-if="canAccess(['admin'])">
        <div
          class="menuRow"
          v-bind:class="[isActive ? 'ativoRow' : 'inativoRow']"
        >
          <div class="icon d-flex justify-content-center align-items-center">
            <font-awesome-icon icon="home" />
          </div>
          <div class="route" v-if="isActive">Início</div>
        </div>
      </router-link>
      <router-link :to="'/admin/Users/ListUsers'" v-if="canAccess(['admin'])">
        <div
          class="menuRow"
          v-bind:class="[isActive ? 'ativoRow' : 'inativoRow']"
        >
          <div class="icon d-flex justify-content-center align-items-center">
            <font-awesome-icon icon="user" />
          </div>
          <div class="route" v-if="isActive">Usuários</div>
        </div>
      </router-link>
      <router-link
        :to="'/admin/CorporateGroup/ListGroups'"
        v-if="canAccess()"
      >
        <div
          class="menuRow"
          v-bind:class="[isActive ? 'ativoRow' : 'inativoRow']"
        >
          <div class="icon d-flex justify-content-center align-items-center">
            <font-awesome-icon icon="briefcase" />
          </div>
          <div class="route" v-if="isActive">Empresas</div>
        </div>
      </router-link>
      <router-link
        :to="'/admin/Companies/ListCompanies'"
        v-if="canAccess()"
      >
        <div
          class="menuRow"
          v-bind:class="[isActive ? 'ativoRow' : 'inativoRow']"
        >
          <div class="icon d-flex justify-content-center align-items-center">
            <font-awesome-icon icon="industry" />
          </div>
          <div class="route" v-if="isActive">Unidade</div>
        </div>
      </router-link>
      <span @click="goToListMachines" v-if="canAccess()">
        <div
          class="menuRow"
          :class="[isActive ? 'ativoRow' : 'inativoRow']"
        >
          <div class="icon d-flex justify-content-center align-items-center">
            <font-awesome-icon icon="cogs" />
          </div>
          <div class="route" v-if="isActive">Máquinas</div>
        </div>
      </span>
      <router-link :to="'/admin/Documents/Index'">
        <div
          class="menuRow"
          v-bind:class="[isActive ? 'ativoRow' : 'inativoRow']"
        >
          <div class="icon d-flex justify-content-center align-items-center">
            <font-awesome-icon icon="file-alt" />
          </div>
          <div class="route" v-if="isActive">Documentos</div>
        </div>
      </router-link>
      <router-link :to="'/admin/Trainings/ListTrainings'">
        <div
          class="menuRow"
          v-bind:class="[isActive ? 'ativoRow' : 'inativoRow']"
        >
          <div class="icon d-flex justify-content-center align-items-center">
            <font-awesome-icon icon="book" />
          </div>
          <div class="route" v-if="isActive">Treinamentos</div>
        </div>
      </router-link>
      <router-link :to="'/admin/Tickets/ListTickets'" v-if="false">
        <div
          class="menuRow"
          v-bind:class="[isActive ? 'ativoRow' : 'inativoRow']"
          v-on:click="clearNotifications()"
        >
          <div
            class="icon d-flex justify-content-center align-items-center"
            style="position: relative"
          >
            <font-awesome-icon icon="comments" />
            <span
              class="badge badge-pill badge-danger"
              style="font-size: 12px; position: absolute; top: -5px; left: 28px"
              v-if="notifications.length > 0"
              >{{ notifications.length }}</span
            >
          </div>
          <div class="route" v-if="isActive">Tickets</div>
        </div>
      </router-link>

      <router-link :to="'/admin/RiskManagement'">
        <div
          class="menuRow"
          v-bind:class="[isActive ? 'ativoRow' : 'inativoRow']"
        >
          <div class="icon d-flex justify-content-center align-items-center">
            <font-awesome-icon icon="chart-line" />
          </div>
          <div class="route" v-if="isActive">Gestão de Riscos</div>
        </div>
      </router-link>
      
<!--      <router-link-->
<!--        :to="'/admin/ServiceOrders/ListServiceOrders'"-->
<!--        v-if="canAccess(['admin'])"-->
<!--      >-->
<!--        <div-->
<!--          class="menuRow"-->
<!--          v-bind:class="[isActive ? 'ativoRow' : 'inativoRow']"-->
<!--        >-->
<!--          <div class="icon d-flex justify-content-center align-items-center">-->
<!--            <font-awesome-icon icon="comments" />-->
<!--          </div>-->
<!--          <div class="route" v-if="isActive">Ordens de Serviço</div>-->
<!--        </div>-->
<!--      </router-link>-->
      <!-- <router-link :to="'/admin/NrReferences/ListReferences'">
        <div class="menuRow" v-bind:class="[ isActive ? 'ativoRow' : 'inativoRow' ]">
          <div class="icon d-flex justify-content-center align-items-center">
            <font-awesome-icon icon="pencil-alt" />
          </div>
          <div class="route" v-if="isActive">Referências</div>
        </div>
      </router-link>-->
    </div>
    <div
      class="top-menu container-fluid"
      v-bind:class="[isActive ? 'ativoTop' : 'inativoTop']"
    >
      <div class="row row100">
        <div class="col-lg-3 col-12">
          <button class="collapseBtn" v-on:click="changeState()">
            <font-awesome-icon icon="bars" />
          </button>
          <div class="logo"></div>
        </div>
        <div class="col-lg-6 col-12 searchCol">
          <div class="form-group w-100 noMargin">
            <input
              class="form-control w-100"
              type="text"
              placeholder="Pesquisar"
              v-if="pesquisar"
            />
          </div>
        </div>
        <div class="col-lg-3 col-12 perfilCol">
          <!-- <font-awesome-icon icon="bell" /> -->
          <router-link
            :to="{ name: 'Tickets_List', params: { id: user_id } }"
            v-if="false"
          >
            <div class="content userInfo mr-3" v-on:click="clearNotifications()">
              <font-awesome-icon icon="comments" style="margin-left: 20px" />
               <span
              class="badge badge-pill badge-danger"
              style="font-size: 12px; position: relative; top: -18px; left: 0px"
              v-if="notifications"
              >{{ notifications.length }}</span
            >
            </div>
          </router-link>
          <router-link :to="{ name: 'Users_New', params: { id: user_id } }">
            <div class="content userInfo">
              <font-awesome-icon icon="user" />
            </div>
          </router-link>
          <div style="margin-left: 1.5vh">
            <button class="btn btn-dark" v-on:click="logout()">
              <font-awesome-icon icon="power-off" />
            </button>
          </div>
        </div>
      </div>
    </div>
    <main>
      <router-view
        :key="`${$route.name}:${$route.params.company_id || ''}:${$route.params.doctype || ''}:${$route.params.id || ''}`"
      ></router-view>
    </main>
  </div>
</template>

<script>
import axios from "@/api/axios";
import { canAccess } from "@/utils/canAccess";
export default {
  name: "dashboard-template",
  components: {},
  data() {
    return {
      pesquisar: false,
      isActive: true,
      role: localStorage.getItem("auth.role"),
      user_id: localStorage.getItem("auth.user_id"),
      notifications: [],
    };
  },
  mounted: function () {
    this.init();

    let currentNotifications = localStorage.getItem("notifications");
    this.notifications = currentNotifications ? JSON.parse(localStorage.getItem("notifications")) : [];

    window.addEventListener('notifications-changed', (event) => {
      this.notifications = event.detail.notifications ?? [] ;
    });
  },
  methods: {
    canAccess,
    init: function () {},
    changeState: function () {
      this.isActive = !this.isActive;
    },
    logout: function () {
      localStorage.setItem("auth.token", "");
      localStorage.setItem("auth.email", "");
      localStorage.setItem("auth.name", "");
      localStorage.setItem("auth.role", "");
      localStorage.setItem("auth.user_id", "");
      localStorage.clear();
      window.location.href = "/";
    },
    goToListMachines() {
      localStorage.removeItem("company_id");
      localStorage.removeItem("companyName");
      localStorage.removeItem('corporate_group_id');
      this.$router.push("/admin/Machines/ListMachines");
    },
    clearNotifications() {
      if (JSON.parse(localStorage.getItem("notifications").length > 0)) {
        let promise = axios.get(
          `${process.env.VUE_APP_API_HOST}/api/admin/clear-notifications`
        );
        promise.then(() => {
          localStorage.setItem("notifications", []);
          this.notifications = [];
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import "../styles/DashboardLayout.scss";
</style>
